import { Injectable } from "@angular/core";
import { LayoutService } from "./layout.service";
@Injectable({
    providedIn: 'root'
})


export class AlertsService {

    constructor(private layoutService: LayoutService) { }

    success(lang, res) {
        return this.layoutService.newMsg({ severity: 'success', summary: '', detail: lang == 'en' ? res.header.messageEn : res.header.message, life: 5000 });
    }


    error(lang, res) {
        this.layoutService.newMsg({ severity: 'error', summary: '', detail: lang == 'en' ? res.header.messageEn : res.header.message, life: 5000 });
    }

    warningForm(lang) {
        this.layoutService.newMsg({
            severity: 'warn', summary: '', detail: lang == 'en' ?
                'To complete the process, you must enter all the required fields' : 'لاتمام العملية يجب ادخال جميع الحقول المطلوبة', life: 5000
        });
    }


    warningList(lang) {
        this.layoutService.newMsg({ severity: 'warn', summary: lang == 'en' ? 'The item must be selected from the list to complete the process' : "يجب اختيار العنصر من القائمة لاتمام العملية ", detail: '', life: 5000 });
    }
    warningForGetListByParent(lang) {
        this.layoutService.newMsg({ severity: 'warn', summary: lang == 'en' ? " Please select type from Dropdown List" : "من فضلك اختر نوع من القائمة المنسدلة", detail: '',life: 5000 });
    }

    warningGeneralMsg(lang,msgAr,msgEn) {
        this.layoutService.newMsg({
            severity: 'warn', summary: '', detail: lang == 'en' ?
                msgEn : msgAr,life: 5000
        });
    }
    
    invalidUserName(lang) {
        this.layoutService.newMsg({ severity: 'warn', summary: lang == 'en' ? 'Invalid UserName' : "اسم المستخدم غير صالح", detail: '', life: 5000 });
    }

    invalidParent(lang) {
        this.layoutService.newMsg({ severity: 'warn', summary: lang == 'en' ? 'Invalid Parent' : "الجهة التابعة نغس الجهة" , detail: '', life: 5000 });
    }

}